<template>
  <div>
    <menuBar></menuBar>
    <div class="cust-container tuition-and-fees">
      <img src="@/assets/images/tuitionandFees/banner.jpg" class="banner" />

      <div class="header-container">
        <h1>Tuition and fees</h1>
        <h4>
          At each level, SCAD tuition covers the cost of the extraordinary
          opportunity a SCAD education provides in the classroom, at networking
          events and in collaboration with leaders in your chosen career field.
        </h4>
      </div>

      <div class="nav-container">
        <div class="nav-list">
          <div class="nav-item">
            <a class="active" href="/T-F-Under-Grad-2026">Undergraduate</a>
            <a href="/T-F-Grad-2026">Graduate</a>
          </div>

          <div class="nav-item">
            <a href="/T-F-Under-Grad-2026">2026-27</a>
            <a class="active" href="/T-F-Under-Grad-2027">2027-28</a>
            <!--            <a class="" href="/T-F-Under-Grad-2023">2022-23</a>-->
            <!--<a href="/T-F-Under-Grad-2022">2021-22</a>-->
            <a
              href="https://scad-minisite.oss-cn-beijing.aliyuncs.com/pdf/202608/2026-27_ENG_Meal_Plans.pdf"
              class="active"
              target="_blank"
              style="
                color: #387cb0;
                background: white;
                border: 1.5px solid #387cb0;
              "
              >Meal Plans</a
            >
          </div>

          <!--          <div class="nav-item" v-if="mealPlans">-->
          <!--            <a-->
          <!--              href="https://scad-minisite.oss-cn-beijing.aliyuncs.com/pdf/2023_24_SCAD_Meal_Plans_ENGLISH_LG.pdf"-->
          <!--              class="active"-->
          <!--              target="_blank"-->
          <!--              style="-->
          <!--                color: #387cb0;-->
          <!--                background: white;-->
          <!--                border: 1.5px solid #387cb0;-->
          <!--              "-->
          <!--              >Meal Plans</a-->
          <!--            ><a href="javascript:void(0);" style="border: 0"></a>-->
          <!--          </div>-->
        </div>
      </div>

      <div class="tuitionand-fees-container section-admission-tuition-and-fees">
        <div id="academic-year-2026-27" class="tab-pane fade active in">
          <p><!-- Undergraduate 2026-27 start --></p>
          <!--          <h3>New student fees</h3>-->
          <!--          <div class="table-responsive">-->
          <!--            <table-->
          <!--              class="-->
          <!--                table table-condensed table-outlined table-bordered-->
          <!--                margin-bottom-all-40-->
          <!--              "-->
          <!--            >-->
          <!--              <thead>-->
          <!--                <tr>-->
          <!--                  <th colspan="2" style="background-color: #f5f5f5">-->
          <!--                    <h4>-->
          <!--                      Application and enrollment fees-->
          <!--                      <span style="font-size: 13px; font-weight: 400"-->
          <!--                        >2026-27</span-->
          <!--                      >-->
          <!--                    </h4>-->
          <!--                    <p>-->
          <!--                      Nonrefundable and nontransferable. For more information,-->
          <!--                      <a-->
          <!--                        href="https://www.scad.edu/about/contact"-->
          <!--                        target="_blank"-->
          <!--                        class="marking-links-processed"-->
          <!--                        data-region="content"-->
          <!--                        >contact admission</a-->
          <!--                      >.-->
          <!--                    </p>-->
          <!--                  </th>-->
          <!--                </tr>-->
          <!--              </thead>-->
          <!--              <tbody>-->
          <!--                <tr>-->
          <!--                  <td>Online application fee</td>-->
          <!--                  <td>$100</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>One-time enrollment fee</td>-->
          <!--                  <td>$500</td>-->
          <!--                </tr>-->
          <!--              </tbody>-->
          <!--            </table>-->
          <!--          </div>-->
          <!--          <h3>-->
          <!--            Tuition<a-->
          <!--              name="tuition"-->
          <!--              class="marking-links-processed"-->
          <!--              data-region="content"-->
          <!--              data-link-type="outgoing"-->
          <!--            ></a>-->
          <!--          </h3>-->
          <!--          <div class="table-responsive">-->
          <!--            <table-->
          <!--              class="-->
          <!--                table table-condensed table-outlined table-bordered-->
          <!--                margin-bottom-all-40-->
          <!--              "-->
          <!--            >-->
          <!--              <thead>-->
          <!--                <tr>-->
          <!--                  <th colspan="3" style="background-color: #f5f5f5">-->
          <!--                    <h4>-->
          <!--                      Undergraduate tuition-->
          <!--                      <span style="font-size: 13px; font-weight: 400"-->
          <!--                        >2026-27</span-->
          <!--                      >-->
          <!--                    </h4>-->
          <!--                    <p>-->
          <!--                      Based on three courses per quarter enrollment for three-->
          <!--                      quarters.-->
          <!--                    </p>-->
          <!--                  </th>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <th>Enrollment type</th>-->
          <!--                  <th>Quarterly tuition</th>-->
          <!--                  <th>Annual tuition</th>-->
          <!--                </tr>-->
          <!--              </thead>-->
          <!--              <tbody>-->
          <!--                &lt;!&ndash;                <tr>&ndash;&gt;-->
          <!--                &lt;!&ndash;                  <td>Full-time undergraduate student</td>&ndash;&gt;-->
          <!--                &lt;!&ndash;                  <td>—</td>&ndash;&gt;-->
          <!--                &lt;!&ndash;                  <td>$42,975</td>&ndash;&gt;-->
          <!--                &lt;!&ndash;                </tr>&ndash;&gt;-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    3 courses per quarter-->
          <!--                    <p class="secondary-text">-->
          <!--                      <em-->
          <!--                        >15 hours of credit, 150 hours of instruction<br />-->
          <!--                        Full-time undergraduate student</em-->
          <!--                      >-->
          <!--                    </p>-->
          <!--                  </td>-->
          <!--                  <td>$14,325</td>-->
          <!--                  <td>$42,975</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    2 courses per quarter-->
          <!--                    <p class="secondary-text">-->
          <!--                      <em-->
          <!--                        >10 hours of credit, 100 hours of instruction<br />-->
          <!--                        ¾ time undergraduate student</em-->
          <!--                      >-->
          <!--                    </p>-->
          <!--                  </td>-->
          <!--                  <td>$9,550</td>-->
          <!--                  <td>—</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    1 course per quarter-->
          <!--                    <p class="secondary-text">-->
          <!--                      <em-->
          <!--                        >5 hours of credit, 50 hours of instruction<br />-->
          <!--                        Less than ½ undergraduate student</em-->
          <!--                      >-->
          <!--                    </p>-->
          <!--                  </td>-->
          <!--                  <td>$4,775</td>-->
          <!--                  <td>—</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>1 credit hour</td>-->
          <!--                  <td>$955</td>-->
          <!--                  <td>—</td>-->
          <!--                </tr>-->
          <!--              </tbody>-->
          <!--            </table>-->
          <!--          </div>-->
          <h3>Housing</h3>
          <div class="table-responsive">
            <table
              class="
                table table-condensed table-outlined table-bordered
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="2" style="background-color: #f5f5f5">
                    <h4>
                      SCADhome application fee
                      <span style="font-size: 13px; font-weight: 400"
                        >2027-28</span
                      >
                    </h4>
                    <p>Nonrefundable and nontransferable</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    The application fee is due before your first quarter of
                    housing. Learn more on the
                    <a
                      href="https://www.scad.edu/life/scadhome/housing-application-and-guidelines"
                      target="_blank"
                      >SCADhome application page</a
                    >.
                  </td>
                  <td>$750</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive">
            <table
              class="
                table
                table-condensed
                table-outlined
                table-bordered
                table-striped
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="6" style="background-color: #f5f5f5">
                    <h4>
                      Savannah
                      <span style="font-size: 13px; font-weight: 400"
                        >2027-28</span
                      >
                    </h4>
                    <p>
                      Annual cost includes the housing application fee and
                      covers fall, winter, and spring quarters.
                    </p>
                  </th>
                </tr>
                <tr>
                  <th>Residence hall</th>
                  <th>Floor plan</th>
                  <th>Total residents</th>
                  <th>Quarterly cost</th>
                  <th>Annual cost</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/barnard-village"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Barnard Village</a
                    >
                  </td>
                  <td>
                    4 bed, 2 bath<br />
                    With kitchen, common space
                  </td>
                  <td>4</td>
                  <td>$4,400</td>
                  <td>$13,950</td>
                </tr>
                <tr>
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/boundary-village"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Boundary Village</a
                    >
                  </td>
                  <td>
                    4 bed, 2 bath<br />
                    With kitchen, common space
                  </td>
                  <td>4</td>
                  <td>$5,000</td>
                  <td>$15,750</td>
                </tr>
                <!-- Chatham (3 rows) -->
                <tr>
                  <td rowspan="3">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/chatham"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Chatham</a
                    >
                  </td>
                  <td>
                    2 bed, 1 bath<br />
                    Suite with common space
                  </td>
                  <td>4</td>
                  <td>$3,750</td>
                  <td>$12,000</td>
                </tr>
                <tr>
                  <td>
                    2 bed, 2 bath<br />
                    Suite with common space
                  </td>
                  <td>4</td>
                  <td>$4,200</td>
                  <td>$13,350</td>
                </tr>
                <tr>
                  <td>1 double-occupancy studio room, 1 bath</td>
                  <td>2</td>
                  <td>$3,600</td>
                  <td>$11,550</td>
                </tr>
                <!-- FORTY EIGHT (4 rows) -->
                <tr>
                  <td rowspan="4">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/forty-eight"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >FORTY EIGHT</a
                    >
                  </td>
                  <td>
                    2 bed, 1 bath<br />
                    Suite
                  </td>
                  <td>4</td>
                  <td>$4,000</td>
                  <td>$12,750</td>
                </tr>
                <tr>
                  <td>1 double-occupancy studio room, 1 bath</td>
                  <td>2</td>
                  <td>$3,600</td>
                  <td>$11,550</td>
                </tr>
                <tr>
                  <td>
                    4 bed, 2 bath<br />
                    Apartment with kitchen, common space
                  </td>
                  <td>4</td>
                  <td>$4,750</td>
                  <td>$15,000</td>
                </tr>
                <tr>
                  <td>
                    2 bed, 1 bath<br />
                    Apartment with kitchen, common space
                  </td>
                  <td>2</td>
                  <td>$4,750</td>
                  <td>$15,00</td>
                </tr>
                <tr>
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/colony-hive"
                      class="marking-links-processed"
                      data-region="content"
                      >The Hive</a
                    >
                  </td>
                  <td>
                    2 bed, 1 bath<br />
                    Suite with common space
                  </td>
                  <td>4</td>
                  <td>$3,750</td>
                  <td>$12,000</td>
                </tr>
                <tr>
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/montgomery-house"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Montgomery House</a
                    >
                  </td>
                  <td>
                    2 bed, 1 bath<br />
                    Suite with common space
                  </td>
                  <td>4</td>
                  <td>$3,500</td>
                  <td>$11,250</td>
                </tr>
                <!-- Oglethorpe House (2 rows) --><!--<tr>
				<td rowspan="2">
					<a href="/life/buildings-and-facilities/oglethorpe-house" target="_blank">Oglethorpe House</a></td>
				<td>
					1 double-occupancy studio room, 1 bath</td>
				<td>
					Shared</td>
				<td>
					2</td>
				<td>
					$3,323</td>
				<td>
					$10,719</td>
			</tr>
			<tr>
				<td>
					1 single-occupancy studio room, 1 bath</td>
				<td>
					Private</td>
				<td>
					1</td>
				<td>
					$3,767</td>
				<td>
					$12,051</td>
			</tr>--><!-- River (2 rows) -->
                <tr>
                  <!--                  rowspan="2"-->
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/river"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >River</a
                    >
                  </td>
                  <td>
                    2 bed, 1 bath<br />
                    Suite with common space
                  </td>
                  <td>4</td>
                  <td>$3,750</td>
                  <td>$12,000</td>
                </tr>
                <!--                <tr>-->
                <!--                  <td>-->
                <!--                    1 bed, 1 bath<br />-->
                <!--                    With common space-->
                <!--                  </td>-->
                <!--                  <td>1</td>-->
                <!--                  <td>$4,500</td>-->
                <!--                  <td>$14,250</td>-->
                <!--                </tr>-->
                <!-- Sail and Surf at Victory Village (3 rows) -->
                <tr>
                  <td rowspan="3">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/sail-victory-village"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Sail</a
                    >
                    and
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/surf-victory-village"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Surf</a
                    >
                    at Victory Village
                  </td>
                  <td>
                    2 bed, 2 bath<br />
                    Suite with common space
                  </td>
                  <td>4</td>
                  <td>$4,200</td>
                  <td>$12,099</td>
                </tr>
                <tr>
                  <td>
                    1 bed, 1 bath<br />
                    Suite with common space
                  </td>
                  <td>2</td>
                  <td>$3,800</td>
                  <td>$12,150</td>
                </tr>
                <tr>
                  <td>1 single-occupancy studio room, 1 bath</td>
                  <td>1</td>
                  <td>$4,500</td>
                  <td>$14,250</td>
                </tr>
                <!-- Sand at Victory Village (3 rows) -->
                <tr>
                  <td rowspan="3">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/sand-victory-village"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Sand at Victory Village</a
                    >
                  </td>
                  <td>
                    4 bed, 2 bath<br />
                    Apartment with kitchen, common space
                  </td>
                  <td>4</td>
                  <td>$5,000</td>
                  <td>$14,500</td>
                </tr>
                <tr>
                  <td>
                    2 bed, 1 bath<br />
                    Apartment with kitchen, common space
                  </td>
                  <td>2</td>
                  <td>$4,600</td>
                  <td>$14,550</td>
                </tr>
                <tr>
                  <td>
                    1 bed, 1 bath<br />
                    Apartment with kitchen, common space
                  </td>
                  <td>1</td>
                  <td>$5,250</td>
                  <td>$16,500</td>
                </tr>
                <!-- Turner House (2 rows) -->
                <!--                <tr>-->
                <!--                  <td rowspan="2">-->
                <!--                    <a-->
                <!--                      href="https://www.scad.edu/life/buildings-and-facilities/turner-house"-->
                <!--                      target="_blank"-->
                <!--                      class="marking-links-processed"-->
                <!--                      data-region="content"-->
                <!--                      >Turner House</a-->
                <!--                    >-->
                <!--                  </td>-->
                <!--                  <td>1 triple-occupancy studio room, 1 bath</td>-->
                <!--                  <td>3</td>-->
                <!--                  <td>$3,105</td>-->
                <!--                  <td>$10,065</td>-->
                <!--                </tr>-->
                <tr>
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/turner-house"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Turner House</a
                    >
                  </td>
                  <td>1 double-occupancy studio room, 1 bath</td>
                  <td>2</td>
                  <td>$3,200</td>
                  <td>$10,500</td>
                </tr>

                <tr>
                  <!--                  rowspan="2"-->
                  <td rowspan="3">Bull Street</td>
                  <td>1 bed, 1 bath Apartment with kitchen, common space</td>
                  <td>1</td>
                  <td>$5,500</td>
                  <td>$17,250</td>
                </tr>

                <tr>
                  <td>2 bed, 1 bath Apartment with kitchen, common space</td>
                  <td>2</td>
                  <td>$5,250</td>
                  <td>$16,500</td>
                </tr>

                <tr>
                  <td>
                    2 bed, 2 bath Apartment with kitchen, common space, each
                    with a private bedroom
                  </td>
                  <td>2</td>
                  <td>$5,500</td>
                  <td>$17,250</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive">
            <table
              class="
                table
                table-condensed
                table-outlined
                table-bordered
                table-striped
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="6" style="background-color: #f5f5f5">
                    <h4>
                      Atlanta
                      <span style="font-size: 13px; font-weight: 400"
                        >2027-28</span
                      >
                    </h4>
                    <p>
                      Annual cost includes the housing application fee and
                      covers fall, winter, and spring quarters.
                    </p>
                  </th>
                </tr>
                <tr>
                  <th>Residence hall</th>
                  <th>Floor plan</th>
                  <th>Total residents</th>
                  <th>Quarterly cost</th>
                  <th>Annual cost</th>
                </tr>
              </thead>
              <tbody>
                <!-- FORTY (3 rows) -->
                <tr>
                  <td rowspan="3">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/forty"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >FORTY</a
                    >
                  </td>
                  <td>
                    4 bed, 2 bath<br />
                    Pod common space
                  </td>
                  <td>8</td>
                  <td>$3,750</td>
                  <td>$12,000</td>
                </tr>
                <tr>
                  <td>
                    2 bed, 1 bath<br />
                    Suite with common space
                  </td>
                  <td>4</td>
                  <td>$3,750</td>
                  <td>$12,000</td>
                </tr>
                <tr>
                  <td>
                    2 bed, 1 bath<br />
                    Apartment with kitchen, common space
                  </td>
                  <td>4</td>
                  <td>$4,400</td>
                  <td>$13,950</td>
                </tr>
                <!-- FORTY FOUR (4 rows) -->
                <tr>
                  <td rowspan="4">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/forty-four"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >FORTY FOUR</a
                    >
                  </td>
                  <td>1 double-occupancy studio room, 1 bath</td>
                  <td>2</td>
                  <td>$3,600</td>
                  <td>$11,550</td>
                </tr>
                <tr>
                  <td>
                    2 bed, 2 bath<br />
                    Suite&nbsp;with common space
                  </td>
                  <td>4</td>
                  <td>$4,200</td>
                  <td>$13,350</td>
                </tr>
                <tr>
                  <td>
                    2 bed, 2 bath<br />
                    Apartment with kitchen, common space
                  </td>
                  <td>4</td>
                  <td>$4,400</td>
                  <td>$13,950</td>
                </tr>
                <tr>
                  <td>1 single-occupancy studio room, 1 bath</td>
                  <td>1</td>
                  <td>$4,500</td>
                  <td>$14,250</td>
                </tr>
                <!-- FORTY FIVE (2 rows) -->
                <tr>
                  <td rowspan="2">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/forty-five"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >FORTY FIVE</a
                    >
                  </td>
                  <td>1 double-occupancy studio room, 1 bath</td>
                  <td>2</td>
                  <td>$3,600</td>
                  <td>$11,550</td>
                </tr>
                <tr>
                  <td>
                    2 bed, 1 bath<br />
                    Suite with common space
                  </td>
                  <td>4</td>
                  <td>$3,750</td>
                  <td>$12,000</td>
                </tr>
                <!-- SCAD House -->
                <tr>
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/scad-house"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >SCAD House</a
                    >
                  </td>
                  <td>
                    2 bed, 1 bath<br />
                    Apartment with kitchen, common space
                  </td>
                  <td>2</td>
                  <td>$4,600</td>
                  <td>$14,550</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--<div class="table-responsive">
            <table class="table table-condensed table-outlined table-bordered margin-bottom-all-40">
              <thead>
                <tr>
                  <th colspan="2" style="background-color: #f5f5f5;">
                    <h4>
                      Summer housing <span style="font-size: 13px; font-weight: 400;">2026-27 (Atlanta, Savannah)</span></h4>
                    <p>*Includes the summer housing application fee.</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Summer housing application fee</td>
                  <td>
                    $250</td>
                </tr>
                <tr>
                  <td>
                    Double-occupancy suite</td>
                  <td>
                    $4,033*</td>
                </tr>
                <tr>
                  <td>
                    Apartment, double-occupancy</td>
                  <td>
                    $4,670*</td>
                </tr>
                <tr>
                  <td>
                    Apartment, private bedroom</td>
                  <td>
                    $4,500*</td>
                </tr>
              </tbody>
            </table>
          </div>-->
          <!--          <h3>Dining</h3>-->
          <!--          <div class="table-responsive">-->
          <!--            <table-->
          <!--              class="-->
          <!--                table table-condensed table-outlined table-bordered-->
          <!--                margin-bottom-all-40-->
          <!--              "-->
          <!--            >-->
          <!--              <thead>-->
          <!--                <tr>-->
          <!--                  <th colspan="3" style="background-color: #f5f5f5">-->
          <!--                    <h4>-->
          <!--                      Meal plan-->
          <!--                      <span style="font-size: 13px; font-weight: 400"-->
          <!--                        >2026-27</span-->
          <!--                      >-->
          <!--                    </h4>-->
          <!--                    <p>-->
          <!--                      Annual meal plan costs are for fall, winter, and spring-->
          <!--                      quarters and assume no changes to the selected plan. Meal-->
          <!--                      plans may be used in Atlanta and Savannah dining-->
          <!--                      locations. Learn more about-->
          <!--                      <a-->
          <!--                        href="https://www.scad.edu/life/dining/meal-plans"-->
          <!--                        target="_blank"-->
          <!--                        class="marking-links-processed"-->
          <!--                        data-region="content"-->
          <!--                        >meal plan options</a-->
          <!--                      >.-->
          <!--                    </p>-->
          <!--                  </th>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <th>Plan</th>-->
          <!--                  <th>Quarterly fee</th>-->
          <!--                  <th>Annual fee</th>-->
          <!--                </tr>-->
          <!--              </thead>-->
          <!--              <tbody>-->
          <!--                <tr>-->
          <!--                  <td>18 meals/week, $75 dining dollars</td>-->
          <!--                  <td>$2,250</td>-->
          <!--                  <td>$6,750</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>14 meals/week, $150 dining dollars</td>-->
          <!--                  <td>$2,225</td>-->
          <!--                  <td>$6,675</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>135 meals/quarter, $125 dining dollars</td>-->
          <!--                  <td>$2,115</td>-->
          <!--                  <td>$6,345</td>-->
          <!--                </tr>-->

          <!--                <tr>-->
          <!--                  <td>10 meals/week, $450 dining dollars</td>-->
          <!--                  <td>$1,950</td>-->
          <!--                  <td>$5,850</td>-->
          <!--                </tr>-->

          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    Apartment meal plan: 50 meals/quarter, $450 dining dollars-->
          <!--                  </td>-->
          <!--                  <td>$1,200</td>-->
          <!--                  <td>$3,600</td>-->
          <!--                </tr>-->

          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    Apartment meal plan: 85 meals/quarter, $75 dining dollars-->
          <!--                  </td>-->
          <!--                  <td>$1,175</td>-->
          <!--                  <td>$3,525</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    Apartment meal plan: 50 meals/quarter, $100 dining dollars-->
          <!--                  </td>-->
          <!--                  <td>$800</td>-->
          <!--                  <td>$2,400</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    Apartment meal plan: 25 meals/quarter, $125 dining dollars-->
          <!--                  </td>-->
          <!--                  <td>$510</td>-->
          <!--                  <td>$1,530</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>Apartment meal plan: $550 dining dollars</td>-->
          <!--                  <td>$525</td>-->
          <!--                  <td>$1,575</td>-->
          <!--                </tr>-->
          <!--              </tbody>-->
          <!--            </table>-->
          <!--          </div>-->
          <!--          <h3>Student health fees</h3>-->
          <!--          <div class="table-responsive">-->
          <!--            <table-->
          <!--              class="-->
          <!--                table table-condensed table-outlined table-bordered-->
          <!--                margin-bottom-all-40-->
          <!--              "-->
          <!--            >-->
          <!--              <thead>-->
          <!--                <tr>-->
          <!--                  <th colspan="2" style="background-color: #f5f5f5">-->
          <!--                    <h4>-->
          <!--                      Annual student health fee-->
          <!--                      <span style="font-size: 13px; font-weight: 400"-->
          <!--                        >2026-27</span-->
          <!--                      >-->
          <!--                    </h4>-->
          <!--                    <p>Savannah campus only, all students</p>-->
          <!--                  </th>-->
          <!--                </tr>-->
          <!--              </thead>-->

          <!--              <tbody>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    HiveHealth is a health care center serving SCAD Savannah.-->
          <!--                    This resource is provided with no co-pays or per-visit fees.-->
          <!--                    This annual fee covers unlimited visits for the academic-->
          <!--                    year. Additional charges may apply.-->
          <!--                    <a-->
          <!--                      href="https://www.scad.edu/life/health-and-wellness/student-health-services"-->
          <!--                      target="_blank"-->
          <!--                      >Learn more</a-->
          <!--                    >-->
          <!--                  </td>-->

          <!--                  <td class="c150pcclass">$125</td>-->
          <!--                </tr>-->
          <!--              </tbody>-->
          <!--            </table>-->
          <!--          </div>-->
          <!--          <div class="table-responsive">-->
          <!--            <table-->
          <!--              class="-->
          <!--                table table-condensed table-outlined table-bordered-->
          <!--                margin-bottom-all-40-->
          <!--              "-->
          <!--            >-->
          <!--              <thead>-->
          <!--                <tr>-->
          <!--                  <th colspan="2" style="background-color: #f5f5f5">-->
          <!--                    <h4>-->
          <!--                      Anthem Student Advantage Health Insurance-->
          <!--                      <span style="font-size: 13px; font-weight: 400"-->
          <!--                        >2026-27</span-->
          <!--                      >-->
          <!--                    </h4>-->
          <!--                    <p>International students only</p>-->
          <!--                  </th>-->
          <!--                </tr>-->
          <!--              </thead>-->

          <!--              <tbody>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    SCAD requires all international students at SCAD to maintain-->
          <!--                    active health insurance throughout the academic year. F-1-->
          <!--                    visa holders are automatically enrolled in the Student-->
          <!--                    Advantage Health Insurance Plan. Students meeting certain-->
          <!--                    requirements may be exempt.-->
          <!--                    <a-->
          <!--                      href="https://www.scad.edu/life/international-student-life/prepare-life-scad/health-care-international-students"-->
          <!--                      target="_blank"-->
          <!--                      >Learn more</a-->
          <!--                    >-->
          <!--                  </td>-->

          <!--                  <td rowspan="2" style="border-bottom: 0" class="c150pcclass">-->
          <!--                    $1,417*-->
          <!--                  </td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td style="border-right: 1px solid #ddd">-->
          <!--                    <p class="secondary-text">-->
          <!--                      <em-->
          <!--                        >* Rate based on Sept. 1, 2026–Aug. 31, 2027, coverage-->
          <!--                        period. Students arriving to SCAD early may be charged-->
          <!--                        an additional fee for extended coverage.</em-->
          <!--                      >-->
          <!--                    </p>-->
          <!--                  </td>-->
          <!--                </tr>-->
          <!--              </tbody>-->
          <!--            </table>-->
          <!--          </div>-->
          <!--          <h3>-->
          <!--            English as a Second Language (ESL) and SCAD Language Studio course-->
          <!--            tuition-->
          <!--          </h3>-->
          <!--          <div class="table-responsive">-->
          <!--            <table-->
          <!--              class="-->
          <!--                table table-condensed table-outlined table-bordered-->
          <!--                margin-bottom-all-40-->
          <!--              "-->
          <!--            >-->
          <!--              <thead>-->
          <!--                <tr>-->
          <!--                  <th colspan="2" style="background-color: #f5f5f5">-->
          <!--                    <h4>-->
          <!--                      ESL 10-week regular session-->
          <!--                      <span style="font-size: 13px; font-weight: 400"-->
          <!--                        >2026-27</span-->
          <!--                      >-->
          <!--                    </h4>-->
          <!--                  </th>-->
          <!--                </tr>-->
          <!--              </thead>-->
          <!--              <tbody>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    Levels I, II, III, IV-->
          <!--                    <p class="secondary-text"><em>20 ESL hours</em></p>-->
          <!--                  </td>-->
          <!--                  <td>$3,568</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    Level V-->
          <!--                    <p class="secondary-text"><em>15 ESL hours*</em></p>-->
          <!--                  </td>-->
          <!--                  <td>$2,676</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    Level VI undergraduate-->
          <!--                    <p class="secondary-text">-->
          <!--                      <em>10 ESL hours</em><em>†</em>-->
          <!--                    </p>-->
          <!--                  </td>-->
          <!--                  <td>$1,784</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td colspan="2">-->
          <!--                    <p class="secondary-text">-->
          <!--                      <em-->
          <!--                        >*ESL course fees only (Students are also required to-->
          <!--                        take an academic studio course and must pay tuition for-->
          <!--                        academic course.)</em-->
          <!--                      >-->
          <!--                    </p>-->
          <!--                  </td>-->
          <!--                </tr>-->
          <!--              </tbody>-->
          <!--            </table>-->
          <!--          </div>-->
          <!--          <div class="table-responsive">-->
          <!--            <table-->
          <!--              class="-->
          <!--                table table-condensed table-outlined table-bordered-->
          <!--                margin-bottom-all-40-->
          <!--              "-->
          <!--            >-->
          <!--              <thead>-->
          <!--                <tr>-->
          <!--                  <th colspan="2" style="background-color: #f5f5f5">-->
          <!--                    <h4>-->
          <!--                      ESL 5-week online LEAP course-->
          <!--                      <span style="font-size: 13px; font-weight: 400"-->
          <!--                        >2026-27</span-->
          <!--                      >-->
          <!--                    </h4>-->
          <!--                  </th>-->
          <!--                </tr>-->
          <!--              </thead>-->
          <!--              <tbody>-->
          <!--                <tr>-->
          <!--                  <td>Learning English for Academic Purposes (5 ESL hours)</td>-->
          <!--                  <td class="c150pcclass">$892</td>-->
          <!--                </tr>-->
          <!--              </tbody>-->
          <!--            </table>-->
          <!--          </div>-->
          <!--          <h3>Lacoste study abroad</h3>-->
          <!--          <div class="table-responsive">-->
          <!--            <table-->
          <!--              class="-->
          <!--                table table-condensed table-outlined table-bordered-->
          <!--                margin-bottom-all-40-->
          <!--              "-->
          <!--            >-->
          <!--              <thead>-->
          <!--                <tr>-->
          <!--                  <th colspan="2" style="background-color: #f5f5f5">-->
          <!--                    <h4>-->
          <!--                      One-quarter Lacoste study abroad fees-->
          <!--                      <span style="font-size: 13px; font-weight: 400"-->
          <!--                        >2026-27</span-->
          <!--                      >-->
          <!--                    </h4>-->
          <!--                    <p>-->
          <!--                      Learn more about the-->
          <!--                      <a-->
          <!--                        href="https://scad-sa.terradotta.com/_portal/tds-program-brochure?programid=10000"-->
          <!--                        target="_blank"-->
          <!--                        class="marking-links-processed"-->
          <!--                        data-region="content"-->
          <!--                        data-link-type="outgoing"-->
          <!--                        >Lacoste study abroad program</a-->
          <!--                      >.-->
          <!--                    </p>-->
          <!--                  </th>-->
          <!--                </tr>-->
          <!--              </thead>-->
          <!--              <tbody>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    Lacoste program deposit-->
          <!--                    <p class="secondary-text">-->
          <!--                      <em>Nonrefundable; applies toward program fee</em>-->
          <!--                    </p>-->
          <!--                  </td>-->
          <!--                  <td>$850</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>Lacoste tuition</td>-->
          <!--                  <td>-->
          <!--                    &lt;!&ndash;                    <a&ndash;&gt;-->
          <!--                    &lt;!&ndash;                      class="smooth-scroll marking-links-processed"&ndash;&gt;-->
          <!--                    &lt;!&ndash;                      href="https://www.scad.edu/admission/tuition-and-fees/undergraduate#tuition"&ndash;&gt;-->
          <!--                    &lt;!&ndash;                      data-region="content"&ndash;&gt;-->
          <!--                    &lt;!&ndash;                      >View tuition fees</a&ndash;&gt;-->
          <!--                    &lt;!&ndash;                    >&ndash;&gt;-->

          <!--                    (See table above for Quarterly tuition costs)-->
          <!--                  </td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    Program fee for room, meals, site visit fees-->
          <!--                    <p class="secondary-text">-->
          <!--                      <em-->
          <!--                        >Participants are responsible for airfare, travel, and-->
          <!--                        all personal expenses, including meals, when outside of-->
          <!--                        Lacoste.</em-->
          <!--                      >-->
          <!--                    </p>-->
          <!--                  </td>-->
          <!--                  <td>$8,825</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>-->
          <!--                    Insurance fee-->
          <!--                    <p class="secondary-text">-->
          <!--                      <em-->
          <!--                        >All students commencing a study abroad program will-->
          <!--                        automatically be enrolled in the SCAD student insurance-->
          <!--                        plan. Costs for this coverage will be added to your bill-->
          <!--                        each quarter. Note: This policy is not meant to be your-->
          <!--                        primary insurance; it is study abroad insurance-->
          <!--                        only.</em-->
          <!--                      >-->
          <!--                    </p>-->
          <!--                  </td>-->
          <!--                  <td>$75</td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td>Administrative fee</td>-->
          <!--                  <td>$50</td>-->
          <!--                </tr>-->
          <!--              </tbody>-->
          <!--            </table>-->
          <!--          </div>-->
          <!-- Undergraduate 2026-27 end -->
        </div>
      </div>
    </div>
    <goTop></goTop>
    <custFooter></custFooter>
  </div>
</template>

<script>
import menuBar from "../../../../components/menuBar/index.vue";
import custFooter from "@/components/footer/Footer";
export default {
  metaInfo: {
    title: "SCAD", // set a title
  },
  name: "TuitionandFees",
  components: {
    menuBar,
    custFooter,
  },
  data() {
    return {
      mealPlans: true,
    };
  },
  created() {
    if (this.$route.query.t === "preview") {
      this.mealPlans = true;
    }
  },
};
</script>

<style scoped lang="less">
@import "../TuitionandFees.less";
</style>
